import { PropsWithChildren, useRef } from "react"
import { cn } from "~/ui-rtk/utils/tailwind-utils"

export type TDropdownMenuOption = {
  label: string
  value: string | number
}

type TDropdownMenuProps = {
  options: TDropdownMenuOption[]
  onItemClick: (val: string | number) => void
  className?: string
  disabled?: boolean
  containerClassName?: string
}

export default function DropdownMenu({
  options,
  children,
  onItemClick,
  disabled,
  className,
  containerClassName,
}: PropsWithChildren<TDropdownMenuProps>) {
  const ref = useRef<HTMLUListElement>(null)
  return (
    <div
      className={cn("dropdown dropdown-start h-system-2xl", containerClassName)}
    >
      <div
        tabIndex={0}
        role="button"
        className={cn("btn btn-ghost rounded-md", className, {
          "opacity-50": disabled,
        })}
      >
        {children}
      </div>
      {!disabled && (
        <ul
          tabIndex={0}
          ref={ref}
          className="menu dropdown-content bg-basic-dark-blue border border-basic-blue rounded-md z-50 mt-1 min-w-40 p-1 shadow-sm top-[52px]"
        >
          {options.map((option, idx) => (
            <li
              onClick={ev => {
                onItemClick(option.value)
                ref.current?.blur()
                ev.stopPropagation()
              }}
              key={`${option.value.toString()}_${idx}`}
            >
              <a>{option.label}</a>
            </li>
          ))}
        </ul>
      )}
    </div>
  )
}
